export default {
  en: {
    federatedGraph: 'Federated network graph',
    formFields: {
      rootOrgFieldsetname: 'Federated entity',
      childOrgListFieldsetName: 'Add sub-entities',
      childOrgFieldsetName: 'Sub-entity {0}',
      organisationName: 'Organisation name',
      organisationWebsite: 'Organisation website',
      logoTooltip: 'We use this to fetch the logo',
      addChildButton: 'Add new child',
      close: 'Close',
      submitForm: 'Update graph',
    },
    settings: 'Settings',
  },
};
